/* eslint-disable max-len */
import React from 'react';
function ChangePassword() {
    return (React.createElement("g", null,
        React.createElement("path", { d: "M18,13h-2.5l3.5,3.5l3.5-3.5H20v-2.1V10c0-1.1-0.9-2-2-2h-1V6c0-2.8-2.2-5-5-5S7,3.2,7,6v2H6c-1.1,0-2,0.9-2,2v10 c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2v-2h-2v2H6V10h12v0.9V13z M15,8H9V6c0-1.7,1.3-3,3-3s3,1.3,3,3V8z M10,15c0,1.1,0.9,2,2,2 s2-0.9,2-2s-0.9-2-2-2S10,13.9,10,15z" })));
}
export default ChangePassword;
